import React, {useEffect, useState} from 'react';
import {useStyles} from '../styles/HomeStyles';
import {inject, observer} from 'mobx-react';
import {closeSideWidth, openSideWidth} from '../../../stores/NavigateStore';
import {Box} from "@material-ui/core";
import EduContentsTopStepper from '../components/EduContentsTopStepper';
import EduContentsButtonGroup from '../components/EduContentsButtonGroup';
import {DayType, EVEN_STEPS, ODD_STEPS} from "../../../common/enums/StepsEnum";
import OddStepOne from './odd/mainText/OddStepOne'
import OddStepTwo from "./odd/Listening/OddStepTwo";
import OddStepThree from "./odd/Listening/OddStepThree";
import OddStepFour from "./odd/Listening/OddStepFour";
import OddStepFive from "./odd/Sentence/OddStepFive";
import OddStepSix from "./odd/Hearing/OddStepSix";
import OddStepSeven from "./odd/Hearing/OddStepSeven";
import EvenStepOne from "./even/Dialogue/dialogueContent/EvenStepOne";
import EvenStepTwo from "./even/Dialogue/dialogueTranslation/EvenStepTwo";
import EvenStepThree from "./even/Writing/EvenStepThree";
import EvenStepFour from "./even/Writing/EvenStepFour";
import EvenStepFive from "./even/Writing/EvenStepFive";
import EvenStepSix from "./even/Speaking/speakingContent/EvenStepSix";
import EvenStepSeven from "./even/Speaking/speakingTranslation/EvenStepSeven";

const EvenContentList = [<EvenStepOne/>,<EvenStepTwo/>,<EvenStepThree/>,<EvenStepFour/>,<EvenStepFive/>,<EvenStepSix/>,<EvenStepSeven/>];
const OddContentList = [ <OddStepOne />, <OddStepTwo />, <OddStepThree/>, <OddStepFour/>, <OddStepFive />,<OddStepSix/>,<OddStepSeven/>];

function Home(props) {

    const classes = useStyles();
    const {sideBarOpen} = props.navigateStore;
    const [dayType,setDayType] = useState('');
    const [activeStep, setActiveStep] = React.useState(0);
    const [steps, setSteps] = React.useState([]);

    const handleNext = () => {
        props.contentStore.setReadyToMoveExit(false);
        props.contentStore.setReadyToSaveStep(false);
        setActiveStep((prevActiveStep) => prevActiveStep + 1);

    };
    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
    const setInitDay = (day) => {
        let steps = "";
        let dayType = "";
        if(day % 2 === 0)  {
            steps = EVEN_STEPS;
            dayType = DayType.EVEN
        } else {
            steps = ODD_STEPS;
            dayType = DayType.ODD
        }
        setSteps(steps);
        setDayType(dayType);
    }
    const getContent = () => {
        if (dayType) {
            return dayType === DayType.ODD ? getOddContent() :  getEvenContent();
        }
    }
    const getEvenContent = () => {
        return EvenContentList[activeStep];
    }
    const getOddContent = () => {
        return OddContentList[activeStep];
    }

    useEffect(() => {

        const step = props.match.params.step;
        const day = props.match.params.day;

        if (step && day) {
            props.contentStore.setCurrentContentPage(true);
            props.contentStore.setStepValue(step);
            props.contentStore.setDayValue(day);
            setInitDay(day);
        }

        return () => {
            props.contentStore.initStepAndDayValue(false);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[props.match.params.step,props.match.params.day]);

    return (
        <div
            className={classes.root}
            style={sideBarOpen ? {width: `calc(100% - ${openSideWidth}px)`} : {width: `calc(100% - ${closeSideWidth}px)`}}
        >
            <Box>
                <EduContentsTopStepper
                    step = {props.contentStore.stepValue}
                    day  = {props.contentStore.dayValue}
                    activeStep = {activeStep}
                    handleBack = {handleBack}
                    handleNext = {handleNext}
                    steps = {steps}
                />
            </Box>
            {getContent()}
            <Box>
                <EduContentsButtonGroup handleBack={handleBack} handleNext = {handleNext} currentStep={activeStep} />
            </Box>
        </div>
    );
}

export default inject('contentStore','navigateStore')(observer(Home))
